export const sessionSetup = async (email, fullname, subcon_id, user_id, direct_attachment, role) => {
    //format locale current datetime
    // let current_datetime = new Date()
    // let formatted_date = current_datetime.getFullYear() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getDate() + " " + current_datetime.getHours() + ":" + current_datetime.getMinutes() + ":" + current_datetime.getSeconds()

    sessionStorage.setItem("email", email)
    sessionStorage.setItem("fullname", fullname)
    sessionStorage.setItem("role", role)
    sessionStorage.setItem("user_id", user_id)
    sessionStorage.setItem("subcon_id", subcon_id)
    sessionStorage.setItem("direct_attachment", direct_attachment)
    // sessionStorage.setItem("loggedIn", true)
    // sessionStorage.setItem("sessionStartTime", formatted_date)
}